<form [formGroup]="fg_hdr" class="fx-row-start-center">

  <gea-mes-datepicker 
    (onDateSelect)="onDateSelection($event)" 
    (onDateInit)="onDateSelection($event)"
    singleDate="false" 
    showLabel="true"
    showCurrentShift="true"
    defaultRange="Current Shift"
    timeRangeOptionalInclude="Rolling 6 Months,Rolling 12 Months,Year to Date"
    showRangeLabel="true"
    [index]="1">
  </gea-mes-datepicker>

  <span> Start Date: </span> 
  <mat-form-field>
    <input formControlName="f_startDate" matInput>
  </mat-form-field>

  <span> End Date: </span> 
  <mat-form-field>
    <input formControlName="f_endDate" matInput>
  </mat-form-field>

</form>